import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActualizacionStepperComponent } from './actualizacion-stepper/actualizacion-stepper.component';

const routes: Routes = [
  {
    path: 'alumno/:id/:returnUrl/:view',
    component: ActualizacionStepperComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ActualizacionDatosRoutingModule { }
